import { PayloadAction } from "@reduxjs/toolkit";
import {
  TRIGGER_PF_PROPOSAL_DETAILS_FETCH_REQUEST,
  pfProposalDetailsLoading,
  pfProposalDetailsFetchSuccess,
  pfProposalDetailsFetchError,
} from "app/redux/features/pf-proposal-details";
import { makeRequest } from "app/utils/makeRequest";
import { all, call, put, takeLatest } from "redux-saga/effects";

function* pfProposalDetailsRequest(
  actions: PayloadAction<{
    proposalId: string;
  }>,
): Generator<any, void, any> {
  try {
    const {
      payload: { proposalId },
    } = actions;
    yield put(pfProposalDetailsLoading());
    const response = yield call(() => makeRequest("pfProposalDetails").get(proposalId, true));
    yield put(pfProposalDetailsFetchSuccess(response.data));
  } catch (err: any) {
    yield put(pfProposalDetailsFetchError(err));
  }
}

function* pfProposalDetailsSaga() {
  yield takeLatest(TRIGGER_PF_PROPOSAL_DETAILS_FETCH_REQUEST, pfProposalDetailsRequest);
}

export default function* pfProposalDetailsSagaRoot() {
  yield all([pfProposalDetailsSaga()]);
}
